export class LegendData {
    Id?: string;
    Name?: string;
    Path?: string;
    Category?: string;
    Color: string;
}